<template>
  <div class="charts-wrap" ref="chartRef"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "CellCharts",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      let chartDom = this.$refs.chartRef;
      let myChart = echarts.init(chartDom);
      window.onresize = myChart.resize;
      this.myChart = myChart;
      this.renderData();
    },
    renderData() {
      let option = {
        grid: {
          top: "0",
          left: "-10",
          right: "0",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: "category",
        },
        yAxis: {
          show: false,
          type: "value",
          scale: true,
          axisLabel: {
            formatter: function() {
              return "";
            },
          },
        },
        series: [
          {
            data: this.dataList,
            type: "line",
            smooth: true,
          },
        ],
      };
      this.myChart.clear();
      this.myChart.setOption(option);
    },
  },
  watch: {
    dataList(value) {
      if (value) {
        this.renderData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.charts-wrap {
  height: 50px;
}
</style>
